import { Theme } from "@mui/material";

export { MprcAppBar } from "./MprcAppBar";
export { MprcAutoSelect } from "./MprcAutoSelect";
export { MprcBarTabs } from "./MprcBarTabs";
export { MprcBarTitle } from "./MprcBarTitle";
export { MprcBoxDrawer } from "./MprcBoxDrawer";
export { MprcButton } from "./MprcButton";
export { MprcButtonDropdown } from "./MprcButtonDropdown";
export { MprcCard } from "./MprcCard";
export { MprcCardActions } from "./MprcCardActions";
export { MprcCardHeaderColor } from "./MprcCardHeaderColor";
export { MprcCardPrimaryText } from "./MprcCardPrimaryText";
export { MprcCheckBox } from "./MprcCheckBox";
export { MprcChipChoice } from "./MprcChipChoice";
export { MprcChipInput } from "./MprcChipInput";
export { MprcChip } from "./MprcChip";
export { MprcClickable } from "./MprcClickable";
export { MprcConfirmDialog } from "./MprcConfirmDialog";
export { MprcContainer } from "./MprcContainer";
export { MprcContainerHCF } from "./MprcContainerHCF";
export { MprcDialogTitleClose } from "./MprcDialogTitleClose";
export { MprcFileSelection } from "./MprcFileSelection";
export { MprcFileUpload } from "./MprcFileUpload";
export { MprcFloatMenuButton } from "./MprcFloatMenuButton";
export { MprcFormBarHeader } from "./MprcFormBarHeader";
export { MprcFormSubHeader } from "./MprcFormSubHeader";
export { MprcHr } from "./MprcHr";
export { MprcIconButton } from "./MprcIconButton";
export { MprcIconButtonDropdown } from "./MprcIconButtonDropdown";
export { MprcIconButtonMoreOptionsDropdown } from "./MprcIconButtonMoreOptionsDropdown";
export { MprcIconFa } from "./MprcIconFa";
export { MprcIconSvg } from "./MprcIconSvg";
export { MprcIconText } from "./MprcIconText";
export { MprcInfiniteLoading } from "./MprcInfiniteLoading";
export { MprcInformationDialog } from "./MprcInformationDialog";
export { MprcJoinComponents } from "./MprcJoinComponents";
export { MprcLine } from "./MprcLine";
export { MprcLink } from "./MprcLink";
export { MprcListItemTitle } from "./MprcListItemTitle"
export { MprcMenuItemCheck } from "./MprcMenuItemCheck";
export { MprcMessageBlock } from "./MprcMessageBlock";
export { MprcMessageBox } from "./MprcMessageBox";
export { MprcPasteContainer } from "./MprcPasteContainer";
export { MprcPrompt } from "./MprcPrompt";
export { MprcRecordInfo } from "./MprcRecordInfo";
export { MprcReorderList } from './MprcReorderList';
export type { ReorderListItem } from './MprcReorderList/ReorderListItem';
export { MprcRequestErrorDialog } from "./MprcRequestErrorDialog";
export { MprcRequestErrorReport } from "./MprcRequestErrorReport";
export { MprcRequestIndicator } from "./MprcRequestIndicator";
export { MprcRoundedBox } from "./MprcRoundedBox";
export { MprcSavingIndicator } from "./MprcSavingIndicator";
export { MprcSpinnerIndicator } from "./MprcSpinnerIndicator";
export { MprcStringToHtml } from "./MprcStringToHtml";
export { MprcTableCell } from "./MprcTableCell";
export { MprcTabs } from "./MprcTabs";
export { MprcText } from "./MprcText";
export { MprcTextMuted } from "./MprcTextMuted";
export { MprcTimezoneSelect } from "./MprcTimezoneSelect";
export { MprcTypography } from "./MprcTypography";
export { MprcTypographyOnDemand } from "./MprcTypographyOnDemand";
export { MprcUserChip } from "./MprcUserChip";

export function ConvertMprcColorsToString(theme: Theme, color: MprcColorsExtended | [MprcColors, MprcColorVariant]) {
    return Array.isArray(color)
        ? theme.palette[color[0]][color[1]]
        : color == "white"
            ? theme.palette.common.white
            : color == "black"
                ? theme.palette.common.black
                : color == "inherit"
                    ? "inherit"
                    : color == "transparent"
                        ? "transparent"
                        : theme.palette[color].main

}
